import React from "react";
import { Link } from "../../molecules/Link";

export const DocenteSidebar = (props) => {
  return (
    <nav
      id={"sidebar"}
      className="flex flex-col min-w-[13rem] min-h-screen bg-theme-blue text-white"
    >
      <Link route={"/docentes"}>{"Lista de Docentes"} </Link>
      <Link route={"/docentes/registrar"}>{"Registrar Docente"}</Link>
      <Link route={"/docentes/plazo-notas"}>{"Plazos para Notas"}</Link>
      <Link route={"/docentes/descargar-notas"}>{"Descargar Notas"}</Link>
      <Link route={"/docentes/descargar-asistencia"}>{"Descargar Asistencia"}</Link>
      <Link route={"/bitacora-asistencias"}>{"Bitácora Asistencias"}</Link>
    </nav>
  );
};
